import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { c } from '@debbie/cortex/dist/index.js';
import * as updatesLib from '@debbie/cortex/dist/api/updates.js';
import { Modal, Button, Input } from './index.js';
const NewUpdateTypeModal = (props) => {
    const { onToggle, onCreate, createDetails } = props;
    const lang = useSelector((s) => s.lang);
    const [loading, setLoading] = useState(false);
    const [newUpdateTypeLabel, setNewUpdateTypeLabel] = useState('');
    return (React.createElement(Modal, { header: lang.updateTypesSettings.addUpdateType, onToggle: () => onToggle(), maxWidth: "300px" },
        React.createElement(Input, { placeholder: lang.updateTypesSettings.title, value: newUpdateTypeLabel, autofocus: true, onChange: (e) => {
                setNewUpdateTypeLabel(e.target.value);
            }, onKeyDown: async (e) => {
                if (e.key === 'Enter' && newUpdateTypeLabel && !loading) {
                    setLoading(true);
                    try {
                        const newUpdate = await updatesLib.createType({
                            label: newUpdateTypeLabel,
                            ...createDetails,
                        });
                        await c.updates.types();
                        await onCreate(newUpdate);
                    }
                    catch (error) {
                        console.error(error);
                        alert('Error');
                    }
                    setLoading(false);
                }
            } }),
        React.createElement(Button, { loading: loading, block: true, disabled: !newUpdateTypeLabel, onClick: async () => {
                setLoading(true);
                try {
                    const newUpdate = await updatesLib.createType({
                        label: newUpdateTypeLabel,
                    });
                    await c.updates.types();
                    await onCreate(newUpdate);
                }
                catch (error) {
                    console.error(error);
                    alert('Error');
                }
                setLoading(false);
            } }, lang.updateTypesSettings.addUpdateType)));
};
export default NewUpdateTypeModal;
//# sourceMappingURL=CreateUpdateTypeModal.js.map